<template>
  <div class="content">
    <div class="t-bg">
      <div class="t-title">转盘抽奖</div>
      <div class="t-chance">剩余抽奖次数：{{ chance }}</div>
      <div class="t-choujiang t-flex-row" :style="{
        width: `${rulette.radius}px`,
        height: `${rulette.radius}px`,
      }">
        <LuckyWheel
          class="luck-draw"
          ref="LuckyWheel"
          :width="325"
          :height="325"
          :defaultConfig="defaultConfig"
          :buttons="buttons"
          :blocks="blocks"
          :prizes="prizeList"
          @end="luckyEnd"
        />
      </div>
      <div class="t-draw t-flex-row" :class="{ disabled }" @click="start">
        {{ chance <= 0 ? '次数已用完' : '立即抽奖' }} </div>
          <div class="t-tip">
            中奖金额请至【我的钱包】-【账单】中查看
          </div>
      </div>
      <!-- 规则部分 -->
      <div class="t-bottom">
        <div class="t-luck-wrapper">
          <div class="t-title">抽奖记录</div>
          <div class="t-history">
            <div class="t-history-theader">
              <span class="t-history-th">抽奖时间</span>
              <span class="t-history-th">奖励</span>
            </div>
            <div class="t-history-tbody">
              <div class="t-history-wrapper" :style="{ transform: `translateY(${scrollTop}px)` }">
                <div class="t-history-tr" v-for="(item, index) in historyList" :key="index">
                  <span class="t-history-td">{{ item.createTime }}</span>
                  <span class="t-history-td">{{
                    item.prizeType == 0 ? "谢谢参与" : `抽中${item.prizeMoney}元`
                  }}</span>
                </div>
              </div>
              <div class="nodata" v-if="historyList.length == 0">
                暂无抽奖记录
              </div>
            </div>
          </div>
          <div class="t-title">活动规则说明</div>

          <div class="t-rule" v-html="rules">
            <!-- <span
            >1.无门槛参与：凡是授权获取电话号码的小程序用户均可参与抽奖；</text
          >
          <span
            >2.每个用户每天默认有一次抽奖资格，用户可以通过以下方式复活继续参与抽奖：
            （1）通过观看品牌视频5秒钟每天获取一次复活资格
            （2）通过一键分享朋友圈（且有人点击）获取复活资格，每分享一个新的朋友，获取一次复活资格，复活次数上不封顶；</text
          >
          <span
            >3.中奖奖品以现金的形式下发用户微信零钱，到账时间不超过24小时,具体到账时间以微信支付通知为准（因微信官方要求，微信实名认证用户方可收到奖金）；</text
          >
          <span>4.中奖记录在个人中心-我的红包中查看。</span> -->
          </div>
        </div>
      </div>
      <!-- 抽奖结束弹窗 -->
      <kevy-mask :show="isShowAwd" @click="toConfirmAwd">
        <img class="winBg" v-if="drawIdx != null && currentPrizeType != 0" src="./imgs/modalBg2.png" mode="" />
        <div class="t-full t-flex-row" :class="{ loser: drawIdx != null && currentPrizeType == 0 }">
          <div class="t-tk-modal" v-if="drawIdx != null && currentPrizeType != 0">
            <div class="t-tk-bg t-bg-full">
              <div class="t-tk-main">
                <div class="t-tk-title">恭喜您抽中</div>
                <div class="t-tk-result">
                  <span>{{ drawPrize }}</span>
                  <span class="unit">元</span>
                </div>
                <div class="t-tk-desc">
                  <div>-已发放至奖励账户-</div>
                  <div>请至【我的钱包】-【账单】中查看</div>
                </div>
              </div>
            </div>
          </div>
          <div class="t-tk-modal loser" v-if="drawIdx != null && currentPrizeType == 0">
            <img class="loserTitleBg" src="./imgs/xiexiecanyu.png" alt="" />
            <div class="t-tk-bg t-bg-full">
              <div class="t-tk-main">
                <span class="t-tk-title">{{ currentPrize }}</span>
              </div>
            </div>
          </div>
        </div>
        <div @click="toConfirmAwd" class="t-tk-btn t-bg-full" :class="{ loser: drawIdx != null && currentPrizeType == 0 }">
          <span>好的</span>
        </div>
      </kevy-mask>
    </div>
</template>

<script>
// nuxt服务端渲染出现报错，判断是否在客户端才渲染
let LuckyWheel;
if (process.browser) {
  LuckyWheel = require('vue-luck-draw').LuckyWheel;
}

import { getListofWinners, getPrizeInformation, getDrawward } from "@/api/index";
import {
  Toast
} from "vant";
import kevyMask from "./kevy-mask.vue";
export default {
  components: {
    kevyMask,
    LuckyWheel
  },
  props: {
    activityId: {
      type: [String, Number],
      default: "",
    },
    chance: {
      type: [String, Number],
      default: 0
    },
    rules: {
      type: String,
      default: ""
    }
  },
  computed: {
    disabled() {
      return this.chance <= 0
    }
  },
  data() {
    return {
      defaultConfig: {
        gutter: 5,
        stopRange: 0.5,
        offsetDegree: 0
      },
      buttons: [{
        imgs: [{
          src: require('./imgs/start.png'),
          width: 94,
          height: 94,
          top: -(94)/2,
        }]
      }],
      blocks: [{ padding: '30px', imgs: [{
        src: require('./imgs/jiangpin.png'),
        width: 325,
        height: 325,
        rotate: true,
      }] }],
      rulette: {
        radius: 650 / 2, // 转盘半径
        innnerTimes: 0.78, //转盘内圆大小
        errorRange: 20, // 匀速中奖角度偏离大小
        turns: 10, // 转圈数
      },
      rotate: 0, //度数-抽奖动画
      turning: false, //转盘是否正在转
      isShowAwd: false, //是否显示奖品弹框，抽奖后提示，要么中奖奖品，要么谢谢参与
      drawIdx: null, //抽到的奖品下标，用于指定中奖奖品并旋转转盘到对应奖品处。例如共5个奖品，下标3代表第4个奖品，下标从0开始
      drawPrize: "", // 抽到的奖品名称(随机金额不能从奖品列表查询金额)
      scrollTop: 0,
      timer: null,
      prizeList: [],
      historyList: [],
      currentPrizeType: null, // 当前奖品类型
      currentPrize: null, // 当前奖品内容
    };
  },
  mounted() {
    if (!this.activityId) {
      Toast({
        message: "活动信息获取异常",
        duration: 2000
      });
      return;
    }
    Promise.all([this.getHistoryList(), this.getPrizeList()]);
  },
  methods: {
    // 获取中奖将列表
    getHistoryList() {
      let $ = this;
      getListofWinners({
        activityId: $.activityId,
        pageNum: 1,
        pageSize: 10,
      }, this.$store.getters.getToken)
        .then((res) => {
          if (res.code == 200) {
            $.historyList = res.data.rows;

            if ($.historyList.length < 5) return;

            $.$nextTick(() => {
              // 重置
              clearInterval($.timer);
              $.scrollTop = 0;
              // 滚动完毕重新从底部循环滚动
              let trDom = document.querySelector(".t-history-tr");
              let wrapperHeight = trDom.clientHeight * $.historyList.length;

              if ($.historyList.length < 5) return;

              $.timer = setInterval(() => {
                $.scrollTop -= 1;
                if (Math.abs($.scrollTop) > wrapperHeight) {
                  let tbodyDom = document.querySelector(".t-history-tbody");
                  $.scrollTop = tbodyDom.clientHeight || 0;
                }
              }, 40);
            });
          } else {
            Toast({
              message: res.msg,
              duration: 2000
            });
          }
        });
    },
    // 获取奖品信息
    getPrizeList() {
      getPrizeInformation({
        activityId: this.activityId
      }, this.$store.getters.getToken)
      .then((res) => {
        if (res.code == 200) {
          console.log(res);
          let options_extra = [];
          
          // 自适应样式 3-8个奖项宫格
          let getOptions = function(name) {
            let obj = null;
            let style_coordinate = [
              { 
                numId: 100,
                fonts1: ['15%', 14],
                fonts2: ['13%', 10, '25%', 10],
                imgs: ['12%', '45%']
                
              },{ 
                numId: 8,
                fonts1: ['15%', 16],
                fonts2: ['12%', 14, '28.5%', 12],
                imgs: ['12%', '45%']
                
              }, {
                numId: 7,
                fonts1: ['20%', 16],
                fonts2: ['15%', 14, '32%', 12],
                imgs: ['12%', '45%']
              }, {
                numId: 6,
                fonts1: ['20%', 18],
                fonts2: ['15%', 14, '36%', 12],
                imgs: ['12%', '45%']
              }, {
                numId: 5,
                fonts1: ['20%', 20],
                fonts2: ['16%', 14, '36%', 14],
                imgs: ['12%', '38%']
              }, {
                numId: 4,
                fonts1: ['20%', 20],
                fonts2: ['17%', 14, '38%', 14],
                imgs: ['12%', '32%']
              }, {
                numId:  3,
                fonts1: ['20%', 23],
                fonts2: ['17%', 15, '40%', 15],
                imgs: ['12%', '27%']
              }
            ];
            if(res.data.length > 8) {
              obj = style_coordinate[0]
            }else if(res.data.length < 3) {
              obj = style_coordinate[style_coordinate.length - 1]
            }else {
              obj = style_coordinate.find(item => item.numId == res.data.length);
            }

            return obj[name]
          }
          // 编辑奖品列表， 初始化转盘样式
          res.data.map(item => {
            let obj = {
              ...item,
              background: '#fff6d2',
            };
            if(item.prizeType == 0) {
              obj.fonts = [{ 
                text: item.prize, 
                top: getOptions('fonts1')[0], 
                fontColor: '#e02020', 
                fontSize: getOptions('fonts1')[1], 
                fontWeight: 600 
              }]
            }else {
              obj.fonts = [
                { 
                  text: item.prizeType == 1 ? item.prize : this.getNumber(item.prize), 
                  top: getOptions('fonts2')[0], 
                  fontColor: '#e02020', 
                  fontSize: getOptions('fonts2')[1], 
                  fontWeight: 600 
                },
                { 
                  text: item.prizeType == 1 ? '￥' : '随机', 
                  top: getOptions('fonts2')[2], 
                  fontColor: '#ffffff', 
                  fontSize: getOptions('fonts2')[3], 
                  fontWeight: 500 
                }
              ],
              obj.imgs = [
                { 
                  src: require('./imgs/redpacket.png'), 
                  top: getOptions('imgs')[0], 
                  width: getOptions('imgs')[1] 
                }
              ]
            }

            options_extra.push(obj)
          })
          this.prizeList = options_extra
        } else {
          Toast({
            message: res.msg,
            duration: 2000
          });
        }
      });
    },
    /**
     * 抽奖按钮点击
     */
    start() {
      if(this.turning) return;

      if (!this.activityId) {
        Toast({
          message: "活动信息获取异常",
          duration: 2000
        });
        return;
      }

      if (!this.prizeList.length) {
        Toast({
          message: "暂无奖池信息",
          duration: 2000
        });
        return;
      }

      if (this.chance <= 0) {
        Toast({
          message: "抽奖机会已用完",
          duration: 2000
        });
        return;
      }

      this.$nextTick(async () => {
        let $ = this;
        $.$refs.LuckyWheel.init();
        //开始转动，若无结果，一直转动
        $.turning = true;
        $.$refs.LuckyWheel.play();

        const res = await getDrawward({
          activityId: $.activityId
        }, this.$store.getters.getToken);
        try {
          if (res.code == 200) {
            let awardIdx = $.prizeList.findIndex(
              (item) => item.id == res.data.id
            );
            // 记录当前抽到奖品类型
            this.currentPrizeType = res.data.prizeType;
            this.currentPrize = res.data.prize;
            this.drawPrize = res.data.realMoney;
            this.drawIdx = awardIdx; 

            // 未匹配到奖项
            if (awardIdx === -1) {
              Toast({
                message: "未在奖池匹配到对应奖项"
              });
              return;
            }

            $.$refs.LuckyWheel.stop(this.drawIdx);
            this.$emit('on-update');          //重置次数

          }else {
            Toast({
              message: res.msg || "请求失败",
              type: "fail",
              onOpened: () => {
                $.turning = false;
                // $.$refs.LuckyWheel.stop();
              }
            });
          }

        } catch (error) {
          Toast({
            message: res.msg || "请求失败",
            type: "fail",
            onOpened: () => {
              $.turning = false;
              // $.$refs.LuckyWheel.stop();
            }
          });
        }
      })
    },

    /**
     * 结束后动画
     */
    luckyEnd(prize) {
      console.log(prize)
      this.getHistoryList(); // 重置抽奖记录
      this.turning = false;
      this.isShowAwd = true;
      this.$emit('on-over')
    },

    /**
     * 确认奖品按钮点击事件
     */
    toConfirmAwd() {
      //这里中奖信息关闭弹框
      this.isShowAwd = false;
      this.turning = false;
      this.$refs.LuckyWheel.init();
    },
    // 获取随机金额中最大金额
    getNumber(str) {
      const parts = str.split('-');
      if (parts.length > 1) {
        return parts[1];
      }
      return '';
    }
  },
};
</script>

<style scoped>
.content {
  width: 100%;
  box-sizing: border-box;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-image: url(./imgs/DZP_BJ.png);
  background-color: #e92b07;
  overflow: hidden;
}

.t-bg {
  width: 100%;
  box-sizing: border-box;
  position: relative;
  overflow-x: hidden;
  box-sizing: border-box;
  padding-top: 90px;
}

.t-title {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.t-title::before {
  margin-right: 10px;
  content: "";
  display: block;
  width: 34px;
  height: 12px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  transform: rotate(-180deg);
  background-image: url(./imgs/titleBg.png);
}

.t-title::after {
  margin-left: 10px;
  content: "";
  display: block;
  width: 34px;
  height: 12px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url(./imgs/titleBg.png);
}

.t-chance {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  color: #ffffff;
}

.t-choujiang {
  margin: 0px auto;
  position: relative;
}

.t-draw {
  width: 300px;
  height: 60px;
  margin: 4px auto 20px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url(./imgs/anniu.png);
  font-size: 22px;
  color: #ffffff;
}

.t-draw.disabled {
  color: #858687;
  cursor: not-allowed;
  pointer-events: none;
  background-image: url(./imgs/anniu_disabled.png);
}

.t-draw:not(.dis):hover {
  opacity: .7;
  transform: scale(.98);
}

.t-tip {
  max-width: 80%;
  text-align: center;
  color: #bb3700;
  font-size: 12px;
  margin: 0 auto 20px;
}

.t-zp {
  width: 325px;
  height: 325px;
  /* background-color: #b4752d; */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* background-image: url(./imgs/jiangpin.png); */
}

.paper {
  width: 325px;
  height: 325px;
  position: absolute;
  margin-top: 5px;
}

.rulette {
  position: absolute;
  z-index: 3;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  display: flex;
  background: linear-gradient(180deg, #fffcf1 0%, #fff6d2 100%);
}

.rulette-item {
  position: absolute;
  left: 50%;
  top: 0;
  height: 50%;
  z-index: 4;
  transform-origin: 0 100%;
  text-align: center;
}

.rulette-item.noPrize .rulette-item-text {
  font-size: 21px;
  width: 60px;
  font-weight: 600;
  margin-top: 16px;
}

.rulette-item-bar {
  position: absolute;
  left: 50%;
  top: 0;
  z-index: 4;
  width: 5px;
  height: 100%;
  transform-origin: 0 100%;
  background-color: #fd8b2f;
}

.rulette-item-img {
  position: absolute;
  left: 50%;
  top: 45px;
  z-index: 5;
  transform: translate(-50%, -50%);
  width: 60%;
  max-width: 77px;
}

.rulette-item-text {
  font-weight: 600;
  position: absolute;
  left: 50%;
  top: 32.5px;
  z-index: 5;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: #e02020;
}

.rulette-item-random {
  font-weight: 500;
  position: absolute;
  left: 50%;
  top: 65px;
  z-index: 99;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #fff;
}

.rulette-item-symbol {
  font-weight: 500;
  position: absolute;
  left: 50%;
  top: 65px;
  z-index: 99;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #fff;
}

.t-start {
  width: 94px;
  height: 94px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: -4px;
  z-index: 9;
}

.t-bottom {
  position: relative;
  margin: 0 10px 20px;
  box-sizing: border-box;
  padding: 0 0 15px;
  background-size: 100% 15px;
  background-image: url(././imgs/RBGB.png);
  background-position: left 0 bottom 2px;
  background-repeat: no-repeat;
  margin-bottom: 20px;
}

.t-luck-wrapper {
  min-height: 350px;
  position: relative;
  box-sizing: border-box;
  background-color: #ffffff;
  padding: 20px 10px;
}

.t-luck-wrapper .t-title {
  position: static;
  color: #e02020;
  font-size: 14px;
  transform: translate(0);
}

.t-luck-wrapper .t-title::before,
.t-luck-wrapper .t-title::after {
  width: 86px;
  height: 6px;
  background-image: url(./imgs/rtBg.png);
}

.t-history {
  padding: 7px 0;
  margin: 15px auto 18px;
  background-color: #fff6e9;
  display: table;
  width: 100%;
}

.t-history-theader,
.t-history-tbody {
  width: 100%;
  /* display: table-row; */
}

.t-history-tbody {
  height: 125px;
  position: relative;
  overflow: hidden;
}

.t-history-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: fit-content;
}

.nodata {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d3843e;
  font-size: 14px;
}

.t-history-theader,
.t-history-tr {
  display: inline-table;
  width: 100%;
}

.t-history-th,
.t-history-td {
  text-align: center;
  padding: 5px;
  display: table-cell;
  font-size: 14px;
  color: #921e03;
}

.t-history-th {
  color: #333333;
}

.t-history-th:first-of-type,
.t-history-td:first-of-type {
  width: 60%;
}

.t-history-th:nth-of-type(2),
.t-history-td:nth-of-type(2) {
  width: 40%;
}

.t-rule {
  font-size: 14px;
  color: #333333;
  margin-top: 20px;
  line-height: 21px;
  padding: 0 5px;
}

.t-full {
  width: 100%;
  background-image: url(./imgs/modalBg2.png);
}

.t-full.loser .t-tk-main {
  padding-top: 16px;
}

.t-full.loser .t-tk-title {
  color: #8f3f1b;
  font-size: 21px;
}

.winBg {
  position: absolute;
  left: 50%; right: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 345px;
  z-index: 2;
}

.t-tk-modal {
  width: 292.5px;
  height: 292.5px;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  background-image: url(./imgs/modalBg1.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 10px;
  padding: 20px 10px 10px;
}

.t-tk-modal.loser {
  width: 274px;
  height: 196px;
  background-image: none;
  background-color: #ffffff;
}

.t-tk-btn {
  width: 235px;
  height: 50px;
  position: absolute;
  left: 50%;
  z-index: 8;
  transform: translate(-50%, -100%);
  font-size: 24px;
  /* font-weight: 600; */
  color: #ffffff;
  line-height: 47px;
  text-align: center;
  margin-top: -25px;
  box-shadow: 0px 3px 16px 0px #b7151f,
    0px 3px 6px 0px rgba(255, 255, 255, 0.64);
  border-radius: 25px;
  background-image: url(./imgs/modalBtn.png);
  background-size: 100% 100%;
}

.t-tk-btn.loser {
  width: 214px;
  height: 42px;
  line-height: 40px;
  margin-top: -20px;
  background-image: url(./imgs/modalBtn2.png);
  box-shadow: none;
  font-size: 16px;
  color: #ffffff;
}

.t-tk-btn:not(.loser) text {
  background: linear-gradient(0deg,
      #f7cb99 0%,
      #f60f0b 26.904296875%,
      #f86f51 78.0029296875%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.loserTitleBg {
  width: 85px;
  height: 85px;
  margin: -45px auto 0;
  display: block;
}

.t-tk-main {
  text-align: center;
}

.t-tk-title {
  color: #ff444b;
  font-size: 21px;
  margin-bottom: 16px;
  font-weight: 600;
}

.t-tk-result {
  background-image: linear-gradient(0deg,
      #f7cb99 0%,
      #f60f0b 26.904296875%,
      #f86f51 78.0029296875%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #ff444b;
  font-size: 60px;
  margin-bottom: 12px;
  line-height: 60px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.t-tk-result text {
  line-height: 1;
}

.t-tk-result .unit {
  font-size: 42px;
  display: inline-block;
}

.t-tk-desc {
  color: #333333;
  font-size: 14px;
  margin-bottom: 12px;
  line-height: 22px;
}

.t-tk-desc div:nth-of-type(1) {
  color: #ff444b;
  font-size: 15px;
  margin-bottom: 30px;
}

.t-tk-desc div:nth-of-type(2) {
  color: #fffefe;
  font-size: 12px;
}

.t-click-class {
  opacity: 0.7;
}
</style>

<style scoped>
.t-flex-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.t-flex-row-sa {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.t-flex-row-sb {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.t-flex-row-s {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.t-flex-row-s-s {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}

.t-flex-row-s-e {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
}

.t-flex-row-e {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  line-height: 30px;
}

.t-flex-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.t-flex-col-sa {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.t-flex-col-sb {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.t-flex-col-s {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.t-flex-col-s-s {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.t-flex-col-s-e {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
}

.t-flex-col-e {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
</style>

<style lang="scss" scoped>
.luck-draw {
  
}
</style>